var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam__item",class:{
    'exam-free': _vm.exam.price === 0,
    'exam-price': _vm.exam.price > 0,
}},[_c('h4',{staticClass:"exam__item__title"},[_c('b-link',{attrs:{"to":{
            name: 'exam-detail',
            params: { id: _vm.exam.id, slug: _vm.exam.slug }
        },"title":_vm.exam.description}},[_vm._v(_vm._s(_vm.exam.name))])],1),_c('div',{staticClass:"exam__item__time"},[_c('img',{attrs:{"src":require("@/assets/images/time-23.svg"),"width":"30px","alt":"time hsk"}}),_c('span',[_vm._v(_vm._s(_vm.exam.time)+" phút")])]),_c('b-link',{staticClass:"exam__item__btn",attrs:{"to":{
        name: 'exam-detail',
        params: { id: _vm.exam.id, slug: _vm.exam.slug }
        }}},[_vm._v("Xem chi tiết")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }